/**
 * StoreSearchOnMount
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Actions
import { setSearch } from '../../../../services/searches';

// Selectors
import {
    selectLocationSearch,
    selectLocationPathname
} from '../../../../workspaces/react-router-selectors';

interface Props {
    pathname: string;
    search?: string;
}

export class StoreSearchOnMount extends React.Component<Props, State> {
    componentDidMount() {
        const { pathname, search } = this.props;
        this.props.setSearch(pathname, search);
    }

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    search: selectLocationSearch,
    pathname: selectLocationPathname
});

export default connect(
    mapStateToProps,
    { setSearch }
)(StoreSearchOnMount);
